import { modalStyles } from '@/components/Modal/Modal.styles';

export const dcrReviewStyles = {
	footerRoot: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 2,
		width: '100%'
	},

	headerDivider: [modalStyles.edgeDivider, { mb: 2 }],

	changeLabel: {
		fontSize: '0.75rem',
		fontWeight: 500,
		color: '#9CA3AF',
		textTransform: 'uppercase',
		letterSpacing: '0.05em'
	},

	groupSummary: {
		fontSize: '0.875rem',
		fontWeight: 400,
		color: 'text.secondary',
		textTransform: 'none',
		letterSpacing: 'normal'
	},

	nestedFieldsWrapper: {
		borderLeft: '2px solid',
		borderColor: 'divider',
		pl: 1.5
	},

	attachmentGroup: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		gap: 1
	},

	addAttachmentButton: {
		alignSelf: 'flex-start',
		textTransform: 'none',
		fontSize: '0.875rem',
		fontWeight: 500,
		color: 'primary.main',
		backgroundColor: 'transparent',
		'&:hover': {
			backgroundColor: 'transparent'
		},
		'&:hover [data-slot="label"]': {
			textDecoration: 'underline'
		}
	},

	attachmentCount: {
		color: 'text.secondary',
		fontWeight: 400
	},

	submitBtn: {
		'&.Mui-disabled': {
			backgroundColor: 'grey.300',
			opacity: 1
		}
	}
};
